import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ChevronRight = (props: SvgIconProps) => {
  return (
    <SvgIcon width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path fill="currentColor"
            d="M5.646 3.146a.5.5 0 0 0 0 .708L9.793 8l-4.147 4.146a.5.5 0 0 0 .708.708l4.5-4.5a.5.5 0 0 0 0-.708l-4.5-4.5a.5.5 0 0 0-.708 0Z"/>
    </SvgIcon>
  );
};
